import { Injectable } from '@angular/core';
import { IMainToolbarTheme } from 'src/app/interfaces/ux/main-toolbar.theme';
import { ITheme } from 'src/app/interfaces/ux/theme.interface';
import { IWallpaper } from 'src/app/interfaces/ux/wallpaper.interface';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {
  darkMode = true;

  theme: ITheme = null;

  constructor() {
    this.loadTheme();
  }

  get wallpaper(): IWallpaper {
    return this.theme ? this.theme.wallpaper : null;
  }

  get mainToolbar(): IMainToolbarTheme {
    return this.theme ? this.theme.mainToolBar : { opacity: 0 };
  }

  get mainToolbarStyle(): string {
    const color = this.darkMode ? 0 : 255;
    const alpha = this.mainToolbar.opacity;

    return `background-color:rgba(${color},${color},${color},${alpha})!important;`;
  }

  get bright() {
    return this.darkMode ? "dark" : "light";
  }

  get brightContrast() {
    return !this.darkMode ? "dark" : "light";
  }

  async loadTheme() {
    const response = await fetch("/assets/os/themes/default-theme.json");
    this.theme = await response.json();
  }

  toggleDarkMode() {
    this.darkMode = !this.darkMode;
  }
}
